import { EBuildingGatesType } from '../../../../json_query';
import { IBuildingGatesTypesTag } from '../../../state/tags/definitions/building_gates';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const buildingGatesMap = {
  [EBuildingGatesType.Ramp]: 'Ворота на пандусе',
  [EBuildingGatesType.Dock]: 'Ворота докового типа',
  [EBuildingGatesType.Ground]: 'Ворота на нулевой отметке',
};

export const BuildingGatesTypesTagItem = getMultiSelectionParamTagItem<EBuildingGatesType, IBuildingGatesTypesTag>(
  buildingGatesMap,
);
